//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import {
  MediaFilterParamKey,
  RIGHTS_STATUS,
} from '@apis/content-library/contentLibraryApiModel';
import HR from '@components/atoms/hr/HR';
import { CheckboxSetFilter } from '@components/media-filters/CheckboxSetFilter';
import { CollapsibleSection } from '@components/media-filters/CollapsibleSection';
import {
  FilterSection,
  FilterSectionTitle,
  FilterValue,
} from '@components/media-filters/filterSectionModels';
import { MediaLibraryTrackingIds } from '@media-library/constants/mediaLibraryTrackingIds';

export const DEFAULT_RIGHTS_FILTER_SECTION: FilterSection<string> = {
  options: [
    {
      isSelected: false,
      value: RIGHTS_STATUS.OWNED,
      label: 'Owned',
      trackingId: MediaLibraryTrackingIds.RIGHTS_OWNED_CHECKBOX,
    },
    {
      isSelected: false,
      value: RIGHTS_STATUS.APPROVED,
      label: 'Approved',
      trackingId: MediaLibraryTrackingIds.RIGHTS_APPROVED_CHECKBOX,
    },
    {
      isSelected: false,
      value: RIGHTS_STATUS.PENDING,
      label: 'Pending',
      trackingId: MediaLibraryTrackingIds.RIGHTS_PENDING_CHECKBOX,
    },
    {
      isSelected: false,
      value: RIGHTS_STATUS.EXPIRED,
      label: 'Rejected',
      trackingId: MediaLibraryTrackingIds.RIGHTS_REJECTED_CHECKBOX,
    },
    {
      isSelected: false,
      value: RIGHTS_STATUS.NOT_SET,
      label: 'None',
      trackingId: MediaLibraryTrackingIds.RIGHTS_NONE_CHECKBOX,
    },
  ],
  paramKey: 'rightsStatuses',
};

export interface RightsFilterProps {
  isDisabled?: boolean;
  isInitiallyCollapsed?: boolean;
  section?: FilterSection<string>;
  onChange: (
    sections: Map<MediaFilterParamKey, FilterSection<FilterValue>>,
  ) => void;
}

export const RightsFilter = ({
  isDisabled,
  isInitiallyCollapsed,
  onChange,
  section = DEFAULT_RIGHTS_FILTER_SECTION,
}: RightsFilterProps) => (
  <>
    <CollapsibleSection
      isCollapsed={isInitiallyCollapsed}
      title={FilterSectionTitle[section.paramKey]}
    >
      <CheckboxSetFilter
        isDisabled={isDisabled}
        onChange={onChange}
        section={section}
      />
    </CollapsibleSection>
    <HR />
  </>
);
